import React, { createContext, useContext, useState, useEffect } from 'react';
import { getMe } from '../api';

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [modules, setModules] = useState([]);
  const [capabilities, setCapabilities] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await getMe();
      if (data.authenticated) {
        setUser(data.user);
        setModules(data.modules || []);
        setCapabilities(data.capabilities || []);
      } else {
        setUser(null);
        setCapabilities([]);
      }
    } catch {
      setUser(null);
      setCapabilities([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Extraer auth_token de la URL (lo pone el backend en el redirect post-OAuth)
    // Necesario para iOS Safari que bloquea cookies cross-origin (ITP)
    const params = new URLSearchParams(window.location.search);
    const authToken = params.get('auth_token');
    if (authToken) {
      localStorage.setItem('auth_token', authToken);
      params.delete('auth_token');
      const newSearch = params.toString();
      const newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '');
      window.history.replaceState({}, '', newUrl);
    }
    refresh();
  }, []);

  const effectiveRole = () => {
    if (!user) return null;
    return user.role;
  };

  const can = (cap) => capabilities.includes('*') || capabilities.includes(cap);

  return (
    <Ctx.Provider value={{ user, modules, capabilities, loading, refresh, effectiveRole: effectiveRole(), can }}>
      {children}
    </Ctx.Provider>
  );
}

export const useAuth = () => useContext(Ctx);
